var React = require('react');

function BoothCurtain (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M480 0h-32v496a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V32a32 32 0 0 0-32-32zM0 32v464a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h32V0H32A32 32 0 0 0 0 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M416 0v400a48 48 0 0 1-84.7 31 15.07 15.07 0 0 0-22.6 0 48.11 48.11 0 0 1-73.4 0 15.07 15.07 0 0 0-22.6 0 48 48 0 0 1-84.7-31V0z","className":"fa-primary","key":2})]);
}

BoothCurtain.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = BoothCurtain;

BoothCurtain.default = BoothCurtain;
